<script>
import { ref, onMounted } from 'vue'
export default {
  name: 'renderless-interceptor',
  props: {
    /* IntersectionObserver RootMargin */
    offset: {
      type: String,
      default: '0px 0px'
    },
    delay: {
      type: Number,
      default: 2000
    }
  },
  setup (props, { slots }) {
    const component = ref(null)
    const inView = ref(false)
    const handleObserver = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          inView.value = true
          observer.unobserve(component.value)
        }
      })
    }
    const observer = new IntersectionObserver(handleObserver, {
      rootMargin: props.offset
    })
    onMounted(() => {
      setTimeout(() => {
        observer.observe(component.value)
      }, props.delay)
    })
    return () => slots.default({
      component,
      inView: inView.value
    })
  }
}
</script>
